import React, { Component, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { Input, MaskedInput, RadioPublicButton, Select } from '../field-components';
import messages from '../messages';
import makeSelectData from '../selectors';
import { required, validatePassportNum, validatePassportSeries, validateYearX } from '../validators';

class PreliminaryForm extends Component {
  componentDidMount() {
    const { reset } = this.props;
    reset();
  }
  render() {
    const { handleSubmit, captchaUrl, updateCaptcha, appState, intl, reset, change } = this.props;
    const documentType = appState.preliminary_form.values.document_type;

    return (
      <div className="send-appeal-form preliminary-form">
        <form className="card-block clearfix m-b-4" onSubmit={handleSubmit}>
          <div className="col-md-6 note">
            <div className="note-title">
              <FormattedMessage {...messages.note_title} />
            </div>
            <p className="note-warning">
              <FormattedMessage {...messages.note_warning} />
            </p>
            <div className="note-bold-text">
              <FormattedMessage {...messages.note_text} />
            </div>
            <ul className="note-list">
              <li className="note-list-item">
                <FormattedMessage {...messages.note_list_item_one} />
              </li>
              <li className="note-list-item">
                <FormattedMessage {...messages.note_list_item_two} />
              </li>
              <li className="note-list-item">
                <FormattedMessage {...messages.note_list_item_three} />
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-10 col-md-6 nopadding-xs">
            <h4 className="preliminary-form-title" style={{ padding: 0 }}>
              <FormattedMessage {...messages.preliminary_form_title} />
            </h4>
            <div className="item clearfix">
              <Field
                onChange={reset}
                // labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name="document_type"
                validate={[required]}
                component={RadioPublicButton}
                inputValue="passport"
                label={<FormattedMessage {...messages.passport} />}
              />
              <Field
                onChange={reset}
                // labelStyle={{ marginRight: '20px', marginLeft: '20px', lineHeight: 'inherit' }}
                name="document_type"
                validate={[required]}
                component={RadioPublicButton}
                inputValue="birth_certificate"
                label={<FormattedMessage {...messages.birth_certificate} />}
              />
            </div>

            {documentType === 'passport' ? (
              <Fragment>
                <div className="container-fluid">
                  <div className="row">
                    <Field
                      name="person_passport_seria"
                      component={Input}
                      label={<FormattedMessage {...messages.passport_series} />}
                      style={{ textTransform: 'uppercase' }}
                      validate={[required, validatePassportSeries]}
                      className="col-xs-5 col-sm-4 passport-field"
                      maxLength={2}
                      onChange={(e) => {
                        setTimeout(() => {
                          change('person_passport_seria', e.target.value.replace(/[^A-Z ]/i, ''));
                        }, 0);
                      }}
                    />
                    <Field
                      name="person_passport_number"
                      component={Input}
                      label={<FormattedMessage {...messages.passport_number} />}
                      autoComplete="on"
                      validate={[required, validatePassportNum]}
                      className="col-xs-7 col-sm-6 passport-field"
                      maxLength={7}
                      onChange={(e) => {
                        setTimeout(() => {
                          change('person_passport_number', e.target.value.replace(/[^0-9 ]/i, ''));
                        }, 0);
                      }}
                    />
                  </div>
                  {/* <div className="helper-text mt-1" style={{ fontSize: 14 }}>
                    Укажите серию и номер паспорта
                  </div> */}
                </div>
              </Fragment>
            ) : (
              <div className="container-fluid" style={{ padding: '0 15px' }}>
                <div
                  className="row"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <Field name="number" component={Select} style={{ height: 'auto', width: 35, marginLeft: 15 }}>
                    <option value="" />
                    <option value="I-">I</option>
                    <option value="II-">II</option>
                    <option value="III-">III</option>
                    <option value="IV-">IV</option>
                  </Field>
                  <div style={{ margin: '0 5px' }}>—</div>
                  <Field
                    name="cert_series"
                    component={Input}
                    style={{ width: 90, textTransform: 'uppercase' }}
                    label={intl.formatMessage(messages.passport_series)}
                    maxLength={2}
                    onChange={(e) => {
                      setTimeout(() => {
                        change('cert_series', e.target.value.replace(/[^A-ZА-ЯЁҒҲҚЎ]+$/i, ''));
                      }, 0);
                    }}
                  />
                  <Field
                    name="cert_number"
                    component={Input}
                    style={{ width: 160 }}
                    label={intl.formatMessage(messages.passport_number)}
                    autoComplete="on"
                    validate={[required]}
                    maxLength={7}
                    onChange={(e) => {
                      setTimeout(() => {
                        change('cert_number', e.target.value.replace(/[^0-9 ]/i, ''));
                      }, 0);
                    }}
                  />
                </div>
                {/* <div className="helper-text mt-1 mb-2" style={{ fontSize: 14 }}>
                  <FormattedMessage {...messages.cert_helper_text} />
                </div> */}
              </div>
            )}

            <div className="align-items-end col-xs-10 mb-2 mt-2" style={{ paddingRight: 0 }}>
              <label className="">
                <FormattedMessage {...messages.birthdate} />
              </label>

              <Field
                name="person_birth_date"
                component={MaskedInput}
                mask="XX.XX.1111"
                placeholder={intl.formatMessage({
                  id: 'application_form.dd_mm_yy',
                  defaultMessage: 'кун | ой | йил',
                })}
                validate={[required, validateYearX]}
                className="form-control"
              />
            </div>

            <div className="col-xs-12 col-sm-10 align-items-center mb-1 mt-1">
              <label className="mr-1" htmlFor="captcha">
                <FormattedMessage {...messages.captcha} />
              </label>
              <div className="mt-1" style={{ display: 'flex' }}>
                <img
                  src={captchaUrl}
                  style={{ height: '100%', cursor: 'pointer' }}
                  alt="captcha"
                  onClick={updateCaptcha}
                />
                <Field component={Input} id="captcha" autoComplete="off" name="verify_code" validate={[required]} />
              </div>
            </div>
            <div className="form-bottom" style={{ margin: 0 }}>
              <button className="btn submit_btn mr-1" style={{ background: '#2B9ED9', marginRight: 30 }} type="submit">
                <FormattedMessage {...messages.sendButton} />
              </button>
            </div>
            {/* <div className="link" onClick={goToMain}>
              <FormattedMessage {...messages.preliminary_form_link} />
            </div> */}
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  appState: makeSelectData(),
});

export default connect(mapStateToProps)(injectIntl(PreliminaryForm));



// WEBPACK FOOTER //
// ./src/application-form/forms/preliminary-form.js